import { Flex, Tag } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return dateStr;
};

const ActiveFilterTags = ({ filters, onRemove, version }) => {
  const intl = useIntl();

  if (!filters) return null;

  const tags = [];

  if (filters.startDate || filters.endDate) {
    const dateDisplay = [
      filters.startDate && formatDate(filters.startDate),
      filters.endDate && formatDate(filters.endDate),
    ]
      .filter(Boolean)
      .join(' → ');
    tags.push({
      id: 'date',
      label: intl.formatMessage({
        id: 'pages.quality.normative.traceability.list.column.arrivalDate',
      }),
      value: dateDisplay,
      keysToRemove: ['startDate', 'endDate'],
    });
  }

  if (filters.docket_number && filters.docket_number !== '') {
    tags.push({
      id: 'docket_number',
      label: intl.formatMessage({ id: 'docket_number' }),
      value: filters.docket_number,
      keysToRemove: ['docket_number'],
    });
  }

  const recipeValue = filters.recipe;
  if (recipeValue !== undefined && recipeValue !== '' && recipeValue !== null) {
    const displayValue = Array.isArray(recipeValue)
      ? recipeValue.join(', ')
      : recipeValue;
    if (displayValue) {
      tags.push({
        id: 'recipe',
        label: intl.formatMessage({ id: 'recipe' }),
        value: displayValue,
        keysToRemove: ['recipe'],
      });
    }
  }

  const seValue = filters.structural_element;
  if (seValue !== undefined && seValue !== '' && seValue !== null) {
    tags.push({
      id: 'structural_element',
      label: intl.formatMessage({ id: 'structural_element' }),
      value: seValue,
      keysToRemove: ['structural_element'],
    });
  }

  const batchKey = version === 1 ? 'concrete_batch_data.batch_code' : 'tag';
  const batchValue = filters[batchKey];
  if (batchValue !== undefined && batchValue !== '' && batchValue !== null) {
    let displayValue = batchValue;
    if (batchValue === 'null') {
      displayValue = intl.formatMessage({
        id: 'pages.quality.normative.traceability.list.batchForm.noBatch',
      });
    } else if (
      typeof batchValue === 'string' &&
      batchValue.startsWith('like:')
    ) {
      displayValue = batchValue.replace('like:', '');
    }
    tags.push({
      id: 'concrete_batch',
      label: intl.formatMessage({ id: 'concrete_batch' }),
      value: displayValue,
      keysToRemove: [batchKey],
    });
  }

  if (tags.length === 0) return null;

  return (
    <Flex
      gap={8}
      wrap="wrap"
      align="center"
      justify="flex-end"
      style={{ marginBottom: 12, padding: '6px 0' }}
    >
      {tags.map(({ id, label, value, keysToRemove }) => (
        <Tag
          key={id}
          closable
          onClose={(e) => {
            e.preventDefault();
            onRemove(keysToRemove);
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 13,
            padding: '4px 10px',
            margin: 0,
          }}
        >
          <strong style={{ marginRight: 4, position: 'relative', top: '-2px' }}>
            {label}:
          </strong>{' '}
          {value}
        </Tag>
      ))}
    </Flex>
  );
};

ActiveFilterTags.propTypes = {
  filters: PropTypes.object,
  onRemove: PropTypes.func.isRequired,
  version: PropTypes.number,
};

ActiveFilterTags.defaultProps = {
  filters: null,
  version: undefined,
};

export default ActiveFilterTags;
